module.exports = __webpack_public_path__ + "static/media/pricing5.1c679252.png";